export const OWNER_TYPES = [
  {code: 'A', value: 'Authority'},
  {code: 'B', value: 'Commission'},
  {code: 'C', value: 'County'},
  {code: 'D', value: 'District'},
  {code: 'F', value: 'Federal'},
  {code: 'I', value: 'Investor'},
  {code: 'M', value: 'Municipal'},
  {code: 'N', value: 'Nonmunicipal'},
  {code: 'O', value: 'Other'},
  {code: 'S', value: 'State'},
  {code: 'U', value: 'Unknown'}
];